
var debug = require('debug')('CRMMap:Pin');


class Pin extends google.maps.OverlayView {

    constructor(CRMMap, id) {
        super();

        this.CRMMap = CRMMap;
        this.id = id;

        this.position = null;
        this.icons = null;
        this.color = null;
        this.label = null;

        this.isMarked = false;
        this.defaultscale = 16;


        this.circle = null;
        this.marker = null;

        this.show_icon = false;
        this.show_pin = false;
        this.show_area = false;

        this.area_radius = 500;
        this.area_opacity = .5;

        this.updateDOM();
        this.stopEventPropagation();
        this.divPosition = false;

    }

    mark() {
        this.isMarked = true;
    }
    marked() {
        return this.isMarked;
    }

    delete() {
        this.setMap(null);
        this.anchor = null;
    }

    update(position, icons, label) {
        this.position = new google.maps.LatLng(position.lat(), position.lng());
        //the posistion should not change
        var update = (this.icons != icons) || (this.label != label);
        this.icons = icons;
        this.label = label;
        this.isMarked = false;
        if (update) {
            this.updateDOM();
        }

        return this;
    }

    draw() {
        if (this.position) {
            this.divPosition = this.getProjection().fromLatLngToDivPixel(this.position);


          
          

            //---ICON-----------------------
            // Hide the popup when it is far out of view.
            var display = 'none';

            if (this.show_icon) {
                display =
                    Math.abs(this.divPosition.x) < 4000 && Math.abs(this.divPosition.y) < 4000 ?
                        'block' :
                        'none';

            }



            if (display === 'block') {
                this.anchor.style.left = (this.divPosition.x - 8) + 'px';
                this.anchor.style.top = (this.divPosition.y- 8)  + 'px';
            }
            if (this.anchor.style.display !== display) {
                this.anchor.style.display = display;
            }

            this.circle.setMap(this.show_area ? this.getMap() : null);
            this.marker.setVisible(this.show_pin);
            this.circle.setRadius(this.area_radius);

        }
    };


    /** Called when the pin is added to the map. */
    onAdd() {
        this.getPanes().floatPane.appendChild(this.anchor);
    };

    /** Called when the pin is removed from the map. */
    onRemove() {
        if (this.anchor.parentElement) {
            this.anchor.parentElement.removeChild(this.anchor);
        }
    };



    updateDOM() {
     
        if (!this.anchor) {
            this.anchor = document.createElement('div');
            this.anchor.className = 'CRMMap_pinGrp';
            this.anchor.id = "pinID_" + this.id;
            this.CRMMap.element.appendChild(this.anchor);
        }

        this.anchor.innerHTML = '';
        var row = null;
        var lastcolor = null;
        if (this.icons) {
            this.icons.forEach((icon) => {
                var scale = this.defaultscale;
                var icondiv = document.createElement('div');
                var iconimg = document.createElement('img');

                icondiv.className = "CRMMap_pinDiv";

                if (icon.Colorvalue) {
                    icondiv.style["-webkit-filter"] = "drop-shadow(0px 0px 2px " + icon.Colorvalue + ")"
                    icondiv.style["filter"] = "drop-shadow(0px 0px 2px  " + icon.Colorvalue + ")"
                    icondiv.style["background-color"] = icon.Colorvalue;
                    icondiv.style["border-color"] = icon.Colorvalue;
                    lastcolor = icon.Colorvalue;
                }

                iconimg.src =(icon.Iconurl.includes('http')?
                icon.Iconurl:"https://maps.crm-map.com/images/" + icon.Iconurl);
             
                iconimg.width = scale;
                iconimg.height = scale;

             
                iconimg.setAttribute('style', 'width:'+scale+'px !important;height:'+scale+'px !important');


                icondiv.appendChild(iconimg);

                if (!row) {
                    row = document.createElement('div');
                    this.anchor.appendChild(row);
                }
                row.appendChild(icondiv);
                if (row.childNodes.length >= 2) {
                    row = null;
                }
            });

            

            if (this.anchor.style.display === 'block') {
                this.anchor.style.left = (this.divPosition.x - (this.anchor.offsetWidth / 2)) + 'px';
                this.anchor.style.top = (this.divPosition.y- (this.anchor.offsetHeight / 2))  + 'px';
            }

        }

        var labeltext = '';
        if (this.label) {
            labeltext = this.label;
            if (labeltext.length > 10) {
                labeltext = labeltext.substring(0, 10) + '..';
            }

            var label = document.createElement('div');
            label.className = "CRMMap_pinLbl";
            label.innerHTML = labeltext.trim();
     
            this.anchor.appendChild(label);

        }


        this.marker = new google.maps.Marker({
            map: this.CRMMap.map,
            position: this.position,
            animation: google.maps.Animation.DROP,
            title: labeltext
        });

        // Add circle overlay and bind to marker
        this.circle = new google.maps.Circle({
            center: this.position,
            radius: this.area_radius,    // 10 miles in metres
            fillColor: lastcolor,
            fillOpacity: this.area_opacity,
            strokeWeight: 0
        });


        //clicks
        this.clicked = false;
        google.maps.event.addDomListener(this.anchor, 'click',  (e) => {
            this.click();
        });

        google.maps.event.addDomListener(this.circle, 'click',  (e) => {
            this.click();
        });

        google.maps.event.addDomListener(this.marker, 'click',  (e) => {
            this.click();
        });

    };

    click() {
        if ( this.clicked ) {
            return true;
        }
        debug('Click', this.CRMMap);
        this.clicked  = true;
        var doClick = true;
        if (this.CRMMap.onClick) {
            doClick = this.CRMMap.onClick(this);
        }
        debug('doClick',doClick);
        if (doClick) {
          return  this.CRMMap.pins.openinfo(this).then(()=>{ 
                this.clicked =false;
            });    
        }
        this.clicked =false;
    }



    stopEventPropagation() {
        var anchor = this.anchor;
        anchor.style.cursor = 'auto';

        ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart',
            'pointerdown']
            .forEach(function (event) {
                anchor.addEventListener(event, function (e) {
                    e.stopPropagation();
                });
            });
    };


}
module.exports = Pin;
